<template>
  <div>
    The propulsion system type can be defined by the user. It can either be:
    <ul>
      <li>
        <b>Chemical</b>: The propulsion system is based on classical chemical technology with low
        specific impulse but high thrust. This type of propulsion is often modelized as impulsive.
      </li>
      <br />
      <li>
        <b>Electrical</b>: The propulsion system type is electrical like Hall effect thruster.
        This type of propulsion system recover numerous technologies but these often assimilated as low Thrust
        and can be modelized as is.
      </li>
      <br />
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipPropulsionSystemType'
}
</script>
